// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\n  --border-radius-1: 2px;\n  --border-radius-2: 4px;\n  --border-radius-3: 8px;\n  --border-radius-4: 16px;\n  --border-radius-5: 100px;\n}\n\n", ""]);
// Exports
module.exports = exports;
